import React, { useContext } from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { NCRContext } from 'views';

import {
  CreatedBy,
  CreatedDate,
  CustomerNumber,
  Description,
  Liability,
  Reason,
  SODate,
  SONumberSearch,
  Subsidiary,
  NetsuiteNumber,
  ReturnNumber,
  NetsuiteOrdStatus,
  NetsuiteRtnStatus,
  Picker,
  SalesRep,
  NCRType,
  GetAffectedItems,
  AffectedItems,
  ResponsibleParty
} from 'components/form/fields';

const NCRDetail = () => {

  const { state } = useContext(NCRContext);

  return (
    <>
      <Row className={'mb-2'}>
        <Col>
          <Row className={'mb-2'}>
            <Col>
              <h5>NCR Details: {state.ncr.number || ''}
                <hr />
              </h5>
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md>
              <SONumberSearch />              
              <CustomerNumber />
              <SODate />
              <Subsidiary />
              <SalesRep />
              <NetsuiteNumber />
              <NetsuiteOrdStatus />
              <ResponsibleParty />           
            </Col>
            <Col md>
              <CreatedDate />
              <CreatedBy />
              <Liability />
              <Reason />   
              <Picker />   
              <ReturnNumber />
              <NetsuiteRtnStatus />
              <NCRType />
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col>
              <Description />
            </Col>
          </Row>
          <Row className={'my-4 text-center'}>
            <Col>
              <GetAffectedItems />
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col>
              <AffectedItems />
            </Col>
          </Row>
          <hr></hr>
        </Col>
      </Row>
    </>
  )
}

export { NCRDetail };
